import * as log from "loglevel";
import * as React from "react";
import * as zxcvbn from "zxcvbn";

import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";
import { Button, Form, Grid, Icon } from "semantic-ui-react";
import { AuthStore } from "../../../stores/auth-store";
import { EditorPane } from "../../common/editor-pane";

declare var toastr: any;

interface ISetPasswordProps{
	authStore?: AuthStore;
	onNext?(): void;
}

interface ISetPasswordState{
	goodPass: boolean;
	badPassMsg: string;
	meterValue?: number;
	showPasswordComplexity?: boolean;
	meterMessage?: string;
	meterClass?: string;
	passwordComplexityGood: boolean;
	passwordMatchGood: boolean;
	newPassword: string;
	confirmPassword: string;
}

let passwordStrengthValues = {
	"0": "Bad",
	"1": "Bad",
	"2": "Weak",
	"3": "Good",
	"4": "Strong"
};

@inject("authStore") @observer
export class SetPassword extends React.Component<ISetPasswordProps, ISetPasswordState>{


	constructor(props, state){
		super(props, state);

		this.state = {
			"goodPass": false,
			"badPassMsg": null,
			"showPasswordComplexity": false,
			"meterValue": -1,
			"meterClass": "PASSWORDMETER-0",
			"passwordComplexityGood": false,
			"passwordMatchGood": false,
			"newPassword": "",
			"confirmPassword": ""
		};
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleNewPasswordChange = this.handleNewPasswordChange.bind(this);
		this.handleConfirmPasswordChange = this.handleConfirmPasswordChange.bind(this);
	}

	async handleSubmit(e: any){
		e.preventDefault();
		e.stopPropagation();

		if(await this.props.authStore.changePassword(this.state.newPassword)){
			toastr.info("Password Changed");
			if(this.props.onNext){
				this.props.onNext();
			}
		}
	}

	handleNewPasswordChange(e: any){
		this.setState({"newPassword": e.target.value}, () => {
			this.checkPasswordStrength();
			this.setState({"goodPass": this.isPasswordComplexityGood() && this.isPasswordMatchGood(), "passwordComplexityGood": this.isPasswordComplexityGood(), "passwordMatchGood": this.isPasswordMatchGood(), "badPassMsg": this.getPasswordMessage()});
		});
	}

	handleConfirmPasswordChange(e: any){
		this.setState({"confirmPassword": e.target.value}, () => {
			this.checkPasswordStrength();
			this.setState({"goodPass": this.isPasswordComplexityGood() && this.isPasswordMatchGood(), "passwordComplexityGood": this.isPasswordComplexityGood(), "passwordMatchGood": this.isPasswordMatchGood(), "badPassMsg": this.getPasswordMessage()});
		});
	}

	isPasswordComplexityGood(){
		return this.state.meterValue > 2;
	}

	isPasswordMatchGood(){
		return this.state.confirmPassword == this.state.newPassword;
	}

	getPasswordMessage(){
		let msg;
		if(!this.isPasswordComplexityGood() && !this.isPasswordMatchGood()){
			msg = "Password doesn't match complexity requirements or confirmation password doesn't match";
		}
		else if(!this.isPasswordComplexityGood()){
			msg = "Password doesn't match complexity requirements";
		}
		else if(!this.isPasswordMatchGood()){
			msg = "Passwords don't match";
		}
		else{
			msg = null;
		}

		return msg;
	}

	checkPasswordStrength(){
		const username = this.props.authStore.loggedIn ? this.props.authStore.user.username : null;
		if(this.state.newPassword.length < 6){
			this.setState({
				"meterValue": 0,
				"meterClass": "PASSWORDMETER-" + 0,
				"showPasswordComplexity": false,
				"meterMessage": "Password must be longer than 6 characters"
			});
		}
		else{
			let similarwords = [];
			if(username){
				similarwords.push(username);
				if(username.indexOf("@") > 0){
					similarwords = similarwords.concat(username.split("@"));
				}
			}
			let result = zxcvbn(this.state.newPassword, similarwords);
			this.setState({
				"meterValue": result.score,
				"meterClass": "PASSWORDMETER-" + result.score,
				"showPasswordComplexity": true,
				"meterMessage": passwordStrengthValues[result.score] + (result.feedback.warning.length > 0 ? ". " + result.feedback.warning : "") + (result.feedback.suggestions.length > 0 ? ". " + result.feedback.suggestions : "")
			});
		}
	}

	render(){
		return(
			<div>
				<Grid columns={2}>
					<Grid.Column>
						<Form onSubmit={this.handleSubmit} style={{"textAlign": "left"}}>
							<Form.Field>
								<Form.Input required type="password" label="New Password" name="newPassword" value={this.state.newPassword} onChange={this.handleNewPasswordChange}  />
							</Form.Field>
							<Form.Field>
								<Form.Input required type="password" label="Confirm Password" name="confirmPassword" value={this.state.confirmPassword} onChange={this.handleConfirmPasswordChange} disabled={this.state.meterValue < 2} />
							</Form.Field>
							<Button type="submit" icon className="jibunu-green" labelPosition="left" disabled={!this.state.goodPass} >
								<Icon name="arrow circle right" />
								Next
							</Button>
						</Form>
					</Grid.Column>
					<Grid.Column verticalAlign="middle" textAlign="center">
						<h4>
							Select a secure password at least 6 characters long
						</h4>
						{this.state.meterValue >= 0 &&
							<div>
								<div className="PASSWORDMETER">
									<div className={this.state.meterClass}></div>
								</div>
								{this.state.showPasswordComplexity && <span> Password Complexity: </span> } <span id="password-strength-text">{this.state.meterMessage}</span>
							</div>
						}
						{!this.state.goodPass && this.state.badPassMsg &&
							<div className="ui yellow icon message">
								<i className="warning sign icon"></i>
								{this.state.badPassMsg}
							</div>
						}
						{this.props.authStore.successMessage &&
							<div className="ui green icon message">
								<i className="checkmark icon"></i>
								{this.props.authStore.successMessage}
							</div>
						}
						{this.props.authStore.errorMessage &&
							<div className="ui red icon message">
								<i className="warning sign icon"></i>
								{this.props.authStore.errorMessage}
							</div>
						}
					</Grid.Column>
				</Grid>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/views/auth/forms/set-password.tsx